<template>
  <div class="alert">
    <!-- 新建&编辑modal -->
    <a-modal
      title=""
      v-model:visible="info.isShow"
      :footer="null"
      :maskClosable="false"
      :centered="true"
      style="min-width: 1200px"
      @cancel="cancel"
    >
      <a-form :model="articleform" ref="addForm" :rules="rules">
        <a-row>
          <a-col span="18">
            <a-form-item
              label="文章标题"
              :label-col="{ span: 3, offset: 1 }"
              :wrapper-col="{ span: 14 }"
              name="docTitle"
            >
              <a-input
                v-model:value="articleform.docTitle"
                style="max-width:480px;"
                placeholder="请输入文章标题"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col span="4">
            <a-form-item :wrapper-col="{ span: 20, offset: 50 }">
              <a-button
                type="primary"
                @click="onSubmit('save')"
                v-if="isShowBtn('sys:article:save')"
                :disabled="
                  articleform.docTitle == null ||
                    articleform.articleTypeId == null
                "
                >提交</a-button
              >
              <a-button
                type="primary"
                style="margin-left: 10px"
                v-if="isShowBtn('sys:article:save') && articleform.status != 1"
                @click="onSubmit('temp')"
                :disabled="
                  articleform.docTitle == null ||
                    articleform.articleTypeId == null
                "
                >暂存</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item
          label="文章简介"
          :label-col="{ span: 3, offset: 0 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-input
            v-model:value="articleform.shortInfo"
            allow-clear
            placeholder="请输入文章简介"
          />
        </a-form-item>
        <a-form-item label="文章分类" :label-col="{ span: 3, offset: 0 }">
          <a-select
            placeholder="必选项"
            v-model:value="articleform.articleTypeId"
            style="width: 200px"
          >
            <a-select-option
              v-for="(item, index) in articletypelist"
              selected
              :key="index"
              :value="item.id"
            >
              {{ item.typeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-row>
          <a-col span="18" style="position: relative;">
            <a-form-item
              label="文章封面"
              name="subjectInfo"
              :label-col="{ span: 3, offset: 1 }"
            >
              <div class="clearfix">
                <a-upload
                  list-type="picture-card"
                  :file-list="imgUrl"
                  :customRequest="customRequestZip"
                  :before-upload="beforeUploadZip"
                  @preview="handlePreview"
                  :remove="removeFile"
                >
                  <div v-if="imgUrl !== null && imgUrl.length < 1">
                    <plus-outlined />
                    <div class="ant-upload-text">上传图片</div>
                  </div>
                </a-upload>
                <a-modal
                  :visible="imgVisible"
                  :footer="null"
                  :keyboard="true"
                  :maskClosable="true"
                  @cancel="showImg"
                >
                  <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
              </div>
            </a-form-item>
            <br />
            <br />
            <div style="position: absolute; top:0;left:300px;">
              图片限制规则如下： <br />
              1、图片支持格式："jpg", "jpeg", "png", "gif"<br />
              2、图片大小：5M <br />
              3、图片比例： <br />
              &nbsp;&nbsp;&nbsp;&nbsp;a、首页-轮播图 16：9<br />
              &nbsp;&nbsp;&nbsp;&nbsp;b、首页-开始使用 16：9 <br />
              &nbsp;&nbsp;&nbsp;&nbsp;c、首页-常用应用推荐 1：1 <br />
              &nbsp;&nbsp;&nbsp;&nbsp;d、首页-进阶技巧4：3 <br />
              &nbsp;&nbsp;&nbsp;&nbsp;e、列表页 4：3
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col span="7">
            <a-form-item
              label="是否立即发布"
              :label-col="{ span: 7, offset: 3 }"
              :wrapper-col="{ span: 9 }"
            >
              <a-radio-group v-model:value="articleform.ispush">
                <a-radio :value="1"> 是 </a-radio>
                <a-radio :value="0"> 否 </a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col span="7">
            <a-form-item
              label="发布时间设置"
              v-show="articleform.ispush == '0'"
              :label-col="{ span: 7, offset: 0 }"
              :wrapper-col="{ span: 10, offset: 0 }"
            >
              <a-date-picker
                placeholder="请选择时间"
                v-model:value="articleform.pushTime"
                @change="onChangePush"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                :defaultValue="
                  moment(new Date(), 'YYYY-MM-DD HH:mm:ss').endOf('day')
                "
                :locale="locale"
                :disabledDate="disabledDate"
                :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item
          label="排序"
          :label-col="{ span: 3, offset: 0 }"
          name="clickNumber"
        >
          <a-input-number
            v-model:value="articleform.orderNumber"
            allow-clear
            :min="1"
          />
        </a-form-item>
        <a-form-item label="内容类型" :label-col="{ span: 3, offset: 0 }">
          <a-radio-group v-model:value="radioValue">
            <a-radio value="1">自定义内容</a-radio>
            <a-radio value="2">公众号内容</a-radio>
            <a-radio value="3">视频号内容</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="视频号ID"
          :label-col="{ span: 3, offset: 0 }"
          :wrapper-col="{ span: 10 }"
          v-if="radioValue == 3"
        >
          <a-input v-model:value="articleform.videoAccountId" />
          <span style="color: red;">注:</span>
          请自行保证视频号ID的正确性，本系统并未做任何格式的限制
        </a-form-item>
        <a-form-item
          label="视频ID"
          :label-col="{ span: 3, offset: 0 }"
          :wrapper-col="{ span: 10 }"
          v-if="radioValue == 3"
        >
          <a-input v-model:value="articleform.everyVideoId" />
          <span style="color: red;">注:</span>
          请自行保证视频ID的正确性，本系统并未做任何格式的限制
        </a-form-item>
        <a-form-item
          label="外部引用URL地址"
          :label-col="{ span: 3, offset: 0 }"
          :wrapper-col="{ span: 10 }"
          v-if="radioValue == 2"
        >
          <a-input v-model:value="articleform.url" />
          <span style="color: red;">注:</span>
          请自行保证URL格式的正确性，本系统并未做任何格式的限制
          <!-- (1)引入外部URL后，发布文章将会使用外部URL链接内容，忽略文章正文
          <span style="padding-left: 24px;">
            (2)请自行保证URL格式的正确性，本系统并未做任何格式的限制
          </span> -->
        </a-form-item>
        <a-form-item
          label="正文"
          :label-col="{ span: 3, offset: 0 }"
          :wrapper-col="{ span: 20, offset: 0 }"
          style="min-height: 440px"
          v-if="radioValue == 1"
        >
          <wangEditor
            v-if="picCode !== ''"
            :attachmentCode="picCode"
            @change="changewangEditor"
            ref="wangEditorRef"
          ></wangEditor>
        </a-form-item>
        <a-form-item
          :wrapper-col="{ span: 4, offset: 3 }"
          v-if="radioValue == 1"
        >
          <a-upload
            style="margin-top: 100px"
            v-model:fileList="fileList"
            name="file"
            :multiple="true"
            @change="handleChange"
            :remove="removeAttach"
            :customRequest="upload"
            :beforeUpload="beforeUpload"
          >
            <a href.prevent="#">上传附件</a>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { getToken } from "@/until/auth";
import { PlusOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  getAttachmentCode,
  getAttachmentList,
  deleteAttachment
} from "@/api/news";
import { nextTick } from "vue";
import { isShowBtn } from "../../../until/tool";
import moment from "moment";
import wangEditor from "@/components/wangEditor.vue";
// const token = localStorage.getItem("token")? JSON.parse(localStorage.getItem("token")): "";
const token = getToken();
let defaultform = {
  articleContent: "",
  articleLab: [],
  articleTypeId: 3,
  attachmentCode: "",
  clickNumber: 1,
  deleted: 0,
  docTitle: null,
  ispush: 1,
  pushTime: moment(new Date(), "YYYY-MM-DD HH:mm:ss").endOf("day"),
  istop: 1,
  shortInfo: "",
  url: "",
  status: 0,
  updateTime: "",
  pictureAttachmentCode: ""
};
const resetItem = { ...defaultform };

export default {
  name: "",
  props: {
    info: {
      type: Object,
      default() {
        return {
          isAdd: true,
          isEdit: false,
          isShow: false
        };
      }
    },
    picCode: {
      type: String,
      default: ""
    }
  },
  data() {
    // const checkClickNumber = async (rule, value) => {
    //   if (!/^[1-9]\d{0,5}$/.test(value)) {
    //     return Promise.reject("请填写数字，数字区间1-999999");
    //   } else {
    //     return Promise.resolve();
    //   }
    // };
    const checkDocTitle = async (rule, value) => {
      if (value.length > 50) {
        return Promise.reject("标题长度能超过50个汉子或字母");
      } else {
        return Promise.resolve();
      }
    };
    return {
      rules: {
        // clickNumber: [
        //   { required: false, validator: checkClickNumber, trigger: "change" }
        // ],
        docTitle: [
          { required: true, validator: checkDocTitle, trigger: "change" }
        ]
      },
      token,
      editor: null,
      id: "",
      fileList: [],
      fileImgList: [],
      dataObj: {},
      addCode: "",
      radioValue: "1", //文章内容类型1正文  2：外部引用   3：引入的视频号
      // picCode: "",
      imgListCode: "",
      acceptTypeEquipZip: ["jpg", "jpeg", "png", "gif"],
      // 图片预览地址
      previewImage: "",
      articleform: {
        articleContent: "",
        articleLab: [],
        articleTypeId: 3,
        attachmentCode: "",
        clickNumber: 1,
        deleted: 0,
        docTitle: null,
        ispush: 1,
        pushTime: moment(new Date(), "YYYY-MM-DD HH:mm:ss").endOf("day"),
        istop: 1,
        shortInfo: "",
        url: "",
        status: 0,
        updateTime: "",
        pictureAttachmentCode: "",
        orderNumber: 1,
        videoAccountId: "",
        everyVideoId: ""
      },
      inputVisible: false,
      inputValue: "",
      imgUrl: [],
      imgVisible: false,
      tagFlag: true,
      uploadImgUrl:
        process.env.VUE_APP_BASE_API + "/assistant/sys/attachment/upload",
      locale: {
        lang: {
          placeholder: "请选择日期",
          today: "今天",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
          ok: "确定",
          timeSelect: "选择时间",
          dateSelect: "选择日期"
        }
      }
    };
  },
  created() {
    //   this.SaveArticle(this.articleform)
    if (this.info.isAdd == true) {
      this.articleform = { ...defaultform };
    }
  },
  async mounted() {
    console.log(this.picCode, "piccode");
    this.SelectArticleTypeList()
      .then(res => {
        if (res.data) {
          // store.commit('SET_ARTICLETYPELIST',res.data)
          this.SET_ARTICLETYPELIST(res.data);
          //   this.newTypeId = res.data[0].id
          this.articleform.articleTypeId = res.data[0].id;
        } else {
          this.$handleErr(res);
        }
      })
      .catch(err => {
        this.$handleErr(err);
      });
  },
  computed: {
    ...mapGetters({
      articletypelist: "news/articletypelist"
    })
  },
  watch: {
    "info.isShow": "getAttachment",
    // "info.isShow": "getAddCode",
    "articleform.docTitle": "titlechange",
    picCode(val, oldVal) {
      //普通的watch监听
      this.uploadImgUrl =
        process.env.VUE_APP_BASE_API +
        "/assistant/sys/attachment/upload?attachmentCode=" +
        val +
        "&readType=public";
    }
  },
  methods: {
    // 获取edit编辑的内容
    changewangEditor(content) {
      this.articleform.articleContent = content;
    },
    // 新建按钮，情况from表单
    addClearForm() {
      this.articleform = {
        articleContent: "",
        articleLab: [],
        articleTypeId: 3,
        attachmentCode: "",
        clickNumber: 1,
        deleted: 0,
        docTitle: null,
        ispush: 1,
        pushTime: moment(new Date(), "YYYY-MM-DD HH:mm:ss").endOf("day"),
        istop: 1,
        shortInfo: "",
        url: "",
        status: 0,
        updateTime: "",
        pictureAttachmentCode: "",
        orderNumber: 1,
        everyVideoId: "",
        videoAccountId: ""
      };
      console.log(this.articleform, "artic");
    },
    // 删除上传文件
    removeFile(file) {
      console.log(this.imgUrl, "imgUrl");
      this.removeAttach(this.imgUrl[0]);
      this.imgUrl = [];
    },
    // 预览图片
    handlePreview() {
      this.imgVisible = true;
      this.previewImage = this.imgUrl[0].ossUrl;
    },
    // 添加列表图片时获取code
    async getAddListImgCode() {
      await getAttachmentCode()
        .then(res1 => {
          this.imgListCode = res1;
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    showImg() {
      this.imgVisible = false;
    },
    // 上传 zip
    customRequestZip(data) {
      this.showUploadMessage = true;
      this.uploadLoadingFlag = true;
      this.secModalFlag = true;
      const formData = new FormData();
      formData.append("file", data.file);
      if (this.dataObj.id) {
        formData.append("attachmentCode", this.dataObj.pictureAttachmentCode);
      } else {
        formData.append("attachmentCode", this.imgListCode);
      }
      formData.append("readType", "public");
      console.log("pictureAttachmentList", formData.pictureAttachmentList);
      // formData.append("token", "aiufpaidfupipiu"); //随便写一个token示例
      this.$store
        .dispatch("news/UploadAttachment", formData)
        .then(res => {
          if (res.code === 0) {
            // notification["success"]({
            //   message: "上传成功"
            // });
            // res.data.forEach(item => {
            //   item.url = item.ossUrl;
            // });
            res.data.name = res.data.attachmentName;
            res.data.url = res.data.ossUrl;
            this.imgUrl = [res.data];
            this.uploadMessage = res.msg;
            this.uploadSuccessFlag = "1";
          } else {
            this.uploadMessage = res.msg;
            this.$message.error("上传失败");
            this.uploadSuccessFlag = "0";
          }
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
        })
        .catch(err => {
          this.uploadLoadingFlag = false;
          this.secModalFlag = false;
          this.$message.error("调用接口失败，请联系管理员" + err);
        });
    },
    // 文件上传前的格式验证 zip
    beforeUploadZip(file) {
      this.fileImgList = [...this.fileImgList, file];
      const uploadSize = file.size / 1024 / 1024 < 50;
      const uploadType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (
        this.acceptTypeEquipZip.length > 0 &&
        this.acceptTypeEquipZip.indexOf(uploadType) === -1
      ) {
        this.$message.error(
          "导入文件只能是" + this.acceptTypeEquipZip.join("、") + "格式!"
        );
        return false;
      }
      if (!uploadSize) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return false;
      }
    },
    moment,
    isShowBtn,
    ...mapMutations({
      SET_ARTICLETYPELIST: "news/SET_ARTICLETYPELIST"
    }),
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment(new Date(), "YYYY-MM-DD HH:mm:ss");
    },

    async getAddCode() {
      await getAttachmentCode()
        .then(res1 => {
          this.addCode = res1;
        })
        .catch(err => {
          this.$handleErr(err);
        });
    },
    async getAttachment(newval, oldval) {
      if (newval == true) {
        // await getAttachmentCode()
        //   .then(res => {
        //     // const _this = this
        //     this.picCode = res;
        //     if (this.info.isAdd == true) {
        //       this.getAddCode();
        //     }
        //   })
        //   .catch(err => {
        //     this.$handleErr(err);
        //   });
        if (this.info.isAdd == true) {
          this.getAddCode();
        }
      }
    },
    titlechange(newval, oldval) {
      if (newval == "") {
        this.articleform.docTitle = null;
      }
    },
    ...mapActions({
      SaveArticle: "news/SaveArticle",
      UpdateArticle: "news/UpdateArticle",
      UploadAttachment: "news/UploadAttachment",
      SelectArticleTypeList: "news/SelectArticleTypeList"
    }),
    handleClose(removedTag) {
      const tags = this.articleform.articleLab.filter(
        tag => tag !== removedTag
      );
      this.articleform.articleLab = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      this.tagFlag = true;
      if (this.inputValue.length > 11) {
        message.error("标签文字长度不能超过10个字", 2);
        this.$refs.input.focus();
        this.tagFlag = false;
        return false;
      }
      let tags = this.articleform.articleLab;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
        this.articleform.articleLab = tags;
      }
      Object.assign(this, {
        inputVisible: false,
        inputValue: ""
      });
    },

    onChangePush(value, dataString) {
      this.articleform.pushTime = value;
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 < 512000;
      if (!isLt2M) {
        message.error(file.name + "文件大小超出限制,请修改后重新上传", 2);
        return false;
      } else {
        return true;
      }
    },
    async upload(data) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this = this;
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("readType", "public");
      if (this.info.isAdd == true) {
        formData.append("attachmentCode", this.addCode);
      } else {
        formData.append("attachmentCode", this.articleform.attachmentCode);
      }
      this.UploadAttachment(formData)
        .then(res => {
          if (res.code === 0) {
            this.fileList = [];
            _this.getAttachlist(res.data.attachmentCode);
          }
        })
        .catch(err => {
          _this.$handleErr(err);
        });
    },
    async removeAttach(data) {
      await deleteAttachment(data.id)
        .then(() => {
          message.success("删除成功");
          this.fileList.splice(data.index, 1);
        })
        .catch(() => {
          message.error("删除失败");
        });
    },
    handleChange(info) {
      // eslint-disable-next-line no-empty
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        message.success(`${info.file.name}上传成功`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name}上传成功`);
      }
    },
    async getAttachlist(attachmentCode) {
      this.fileList = [];
      const res1 = await getAttachmentList({ attachmentCode });
      this.fileList = [];
      if (res1.data) {
        this.fileList = [];
        let index = 0;
        res1.data.forEach(item => {
          this.fileList.push({
            name: item.attachmentName,
            id: item.id,
            index: index++
          });
        });
      }
    },
    async setinfo(val) {
      this.dataObj = val;
      val.articleTypeId = Number(val.articleTypeId);
      this.attachmentCode = val.attachmentCode;

      this.getAttachlist(val.attachmentCode);
      // 获取列表图片
      const res1 = await getAttachmentList({
        attachmentCode: val.pictureAttachmentCode
      });
      this.imgUrl = [];
      if (res1.data) {
        if (res1.data.length > 0) {
          // const imgObj = res1.data[res1.data.length - 1];
          const imgObj = res1.data[0];
          imgObj.url = imgObj.ossUrl;
          this.imgUrl = [imgObj];
        }
        // let index = 0;
        // res1.data.forEach(item => {
        //   this.imgUrl.push({
        //     name: item.attachmentName,
        //     id: item.id,
        //     index: index++
        //   });
        // });
      }
      this.id = val.id;
      const _this = this;
      // 获取新闻信息
      this.$store
        .dispatch("news/SearchArticleInfo", { id: this.id })
        .then(res => {
          if (res.code === 0) {
            this.$nextTick(() => {
              setTimeout(() => {
                defaultform = res.data;
                if (
                  res.data.everyVideoId == "" ||
                  res.data.videoAccountId == "" || res.data.everyVideoId == null ||
                  res.data.videoAccountId == null
                ) {
                  this.radioValue == "3";
                } else if (res.data.url == "" || res.data.url ==null) {
                  this.radioValue == "2";
                } else {
                  this.radioValue == "1";
                  _this.$refs.wangEditorRef.setHtml(res.data.articleContent);
                }
                this.articleform = res.data;
                this.articleform.articleTypeId = Number(res.data.articleTypeId);
              }, 500);
            });
          } else {
            this.$handleErr(res);
          }
        })
        .catch(err => {
          this.$handleErr(err);
        });
      // 手动设置编辑器的内容
      // eslint-disable-next-line @typescript-eslint/no-this-alias

      if (val.articleLabs != null) {
        val.articleLab = val.articleLabs.split(",");
      } else {
        val.articleLab = ["通告"];
      }
      // defaultform = { ...val };
      // this.articleform = { ...val };
      this.articleform.pushTime = moment(
        this.articleform.pushTime,
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    resetForm() {
      this.getAddListImgCode();
      this.$refs.addForm.resetFields();
    },
    onSubmit(saveortemp) {
      const year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let day = new Date().getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      if (this.articleform.pushTime === "" || !this.articleform.pushTime) {
        const time = year + "-" + month + "-" + day + " 23:59:59";
        this.articleform.pushTime = time;
      }
      if (saveortemp == "temp") {
        this.articleform.status = 0;
      } else if (saveortemp == "save") {
        if (this.articleform.ispush == 0) {
          this.articleform.status = 2;
        } else if (this.articleform.ispush == 1) {
          this.articleform.status = 1;
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _this = this;
      if (this.radioValue == 1) {
        this.articleform.articleContent = this.$refs.wangEditorRef.getHtml();
      }
      this.articleform.updateTime = moment(new Date()).format(
        "YYYY-MM-DD hh:mm:ss"
      );
      if (this.radioValue == 3) {
        if (
          this.articleform.videoAccountId == "" ||
          this.articleform.everyVideoId == ""
        ) {
          message.error("视频号ID与视频ID不能为空，请填写后在提交或暂存。");
          return false;
        }
      }

      this.$refs.addForm
        .validate()
        .then(() => {
          if (this.tagFlag === true) {
            if (this.info.isAdd == true) {
              if (this.addCode == "") {
                window.alert("相关数据获取失败，请刷新页面再试");
                return;
              }
              this.articleform.attachmentCode = this.addCode;
              this.articleform.pictureAttachmentCode = this.imgListCode;
              if (this.radioValue == 1) {
                this.articleform.everyVideoId == "";
                this.articleform.videoAccountId == "";
                this.articleform.url = "";
              } else if (this.radioValue == 2) {
                this.articleform.everyVideoId == "";
                this.articleform.videoAccountId == "";
                this.fileImgList = [];
                this.articleform.articleContent = "";
                // this.$refs.wangEditorRef.setHtml("");
              } else {
                this.articleform.url = "";
                this.fileImgList = [];
                this.articleform.articleContent = "";
                // this.$refs.wangEditorRef.setHtml("");
              }
              const rowObj = this.articleform;
              if (moment.isMoment(this.articleform.pushTime)) {
                rowObj.pushTime = this.articleform.pushTime.format(
                  "YYYY-MM-DD hh:mm:ss"
                );
              }

              this.SaveArticle(rowObj)
                .then(res => {
                  message.success("新增文章成功");
                  // eslint-disable-next-line vue/no-mutating-props
                  this.info.isShow = false;
                  _this.articleform = { ...resetItem };
                  _this.fileImgList = [];
                  this.$nextTick(() => {
                    if (_this.radioValue == 1) {
                      this.$refs.wangEditorRef.setHtml("");
                    }
                    this.$emit("clearPicCode");
                  });
                  this.$emit("onSubmit");
                })
                .catch(reason => {
                  message.error("新增文章失败");
                  // eslint-disable-next-line vue/no-mutating-props
                  this.info.isShow = false;
                  _this.articleform = { ...resetItem };
                  _this.fileImgList = [];
                  this.$nextTick(() => {
                    if (_this.radioValue == 1) {
                      this.$refs.wangEditorRef.setHtml("");
                    }
                    this.$emit("clearPicCode");
                  });
                });
            } else {
              if (this.articleform.attachmentCode == "") {
                window.alert("相关数据获取失败，请刷新页面再试");
                return;
              }
              this.articleform.id = this.id;
              // this.articleform.attachmentCode = this.attachmentCode;
              const rowObj = this.articleform;
              if (moment.isMoment(this.articleform.pushTime)) {
                rowObj.pushTime = this.articleform.pushTime.format(
                  "YYYY-MM-DD hh:mm:ss"
                );
              }
              this.UpdateArticle(rowObj)
                .then(res => {
                  message.success("文章修改成功");
                  // eslint-disable-next-line vue/no-mutating-props
                  this.info.isShow = false;
                  _this.articleform = { ...resetItem };
                  if (_this.radioValue == 1) {
                    this.$refs.wangEditorRef.setHtml("");
                  }
                  this.$emit("onSubmit");
                  this.$emit("clearPicCode");
                })
                .catch(reason => {
                  message.error("修改失败");
                  // eslint-disable-next-line vue/no-mutating-props
                  this.info.isShow = false;
                  _this.articleform = { ...resetItem };
                  _this.fileImgList = [];
                  this.$nextTick(() => {
                    if (this.radioValue == 1) {
                      this.$refs.wangEditorRef.setHtml("");
                    }
                    this.$emit("clearPicCode");
                  });
                });
            }
          }
        })
        .catch(error => {
          return false;
        });
    },
    cancel() {
      this.$nextTick(() => {
        if (this.radioValue == 1) {
          this.$refs.wangEditorRef.setHtml("");
        }
        this.$emit("clearPicCode");
      });
      this.articleform = { ...resetItem };
      this.fileImgList = [];
    }
  },
  components: {
    PlusOutlined,
    wangEditor
  },
  filters: {}
};
</script>
<style lang="scss" scoped>
.wangEditor-container {
  min-width: 1030px;
}
.ant-form {
  position: relative;
}
.pushtime {
  position: absolute;
  top: 0;
  left: 0;
}
.ant-modal {
  width: 1118px;
}
</style>
